import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircle';
import SignaturewModal from './SignatureModal';
import CustomButton from 'components/Button/CustomButton';

const SignatureSection = ({
  signature,
  setSignature,
  announcement,
  readOnly,
}) => {
  const [error, setError] = useState(null);
  const [signaturePopup, setSignaturePopup] = useState(false);

  const handleSignatureSave = (signatureValue) => {
    if (!signatureValue || (!signatureValue.text && !signatureValue.type)) {
      setSignature(null);
      return;
    }

    setError(null);
    setSignature({
      value: signatureValue,
    });
    setSignaturePopup(false);
  };

  return (
    <Box
      sx={{
        mb: 3,
        background: '#fff',
        border: '1px solid #EEEEEE',
        borderRadius: '10px',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="subtitle1" fontWeight="700" fontSize={'14px'}>
        {signature?.value && <CheckIcon sx={{ color: '#04B88D', mr: 1 }} />}
        Signature Required
      </Typography>
      {!readOnly ? (
        <CustomButton
          variant="contained"
          sx={{
            borderRadius: '6px',
            padding: '5px 12px',
            fontSize: 12,
            textTransform: 'none',
            marginLeft: 'auto',
          }}
          onClick={() => setSignaturePopup(true)}
          disabled={announcement.status !== 'active'}
        >
          Signature
        </CustomButton>
      ) : null}
      {error && (
        <Typography
          variant="caption"
          color="error"
          sx={{ display: 'block', mt: 1 }}
        >
          {error}
        </Typography>
      )}
      <SignaturewModal
        open={signaturePopup}
        signature={signature?.value}
        onSave={handleSignatureSave}
        onClose={() => setSignaturePopup(false)}
      />
    </Box>
  );
};

export default SignatureSection;
